import { create } from 'zustand';

interface RouteLoadingState {
  loading: boolean;
  setLoading: (loading: boolean) => void;
}

export const useRouteLoading = create<RouteLoadingState>((set) => ({
  loading: false,
  setLoading: (loading: boolean) => set({ loading }),
}));
